// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609231419/js/" + chunkId + "." + {"44":"37d36988","225":"5e640d8e","481":"f11792ef","486":"2378e6ff","770":"71a9f48d"}[chunkId] + ".0.26198946562452186.chunk.js";
};